import base64Url from 'base64url';

export function obfuscate(value: string): string {
  return base64Url.encode(value);
}

export function deobfuscate(value: string): string {
  return base64Url.decode(value);
}
